import { CommissionPlan, PlanValues } from '@model/MultiTierDto'

export const commissionTiers = (commissionPlans?: CommissionPlan[]): PlanValues => {
  const tiers: PlanValues = {}
  commissionPlans?.forEach((plan) => {
    tiers[plan.tradingAccountType.name as keyof PlanValues] = plan.amount
  })
  return tiers
}
